export default [
  {
    name: 'LinkedIn',
    link: 'https://www.linkedin.com/in/tom-colarusso-2650047a/',
    icon: 'LinkedInIcon',
  },
  // {
  //   name: 'Twitter',
  //   link: 'https://twitter.com/etcolarusso',
  //   icon: 'TwitterIcon',
  // },
  // {
  //   name: 'Instagram',
  //   link: 'https://www.instagram.com/hottomdotcom/',
  //   icon: 'InstagramIcon',
  // },
  {
    name: 'Github',
    link: 'https://github.com/Yodablues',
    icon: 'GithubIcon',
  },
];
